import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
// import { environment } from "../../../environments/environment";
import { ConfigService } from '../config.service';
import { WfdssCase } from "src/app/_models/incident/wfdssCase/wfdssCase";
import { Utilities } from "src/app/_helpers/utility/utilities";
import { EInterceptorOptionsHTTPHeaders } from "src/app/_helpers/interceptors/EInterceptorOptionsHTTPHeaders";
import { map } from "rxjs/operators";
import { BehaviorSubject, Observable } from "rxjs";
import { IstrategicActionItem } from 'src/app/_interfaces/strategy/IStrategicActionItem';
import { IstrategicAction } from 'src/app/_interfaces/strategy/IStrategicAction';
import { IReportedStrategy } from 'src/app/_interfaces/strategy/IReportedStrategy';
import { StrategyFeatures } from 'src/app/_models/map/strategy-features';

@Injectable({
  providedIn: "root",
})
export class StrategicActionService {
  private readonly baseUrl = this.environment.caseApi.baseUrl;
  // Strategy Features Behavior subject and observable to use when updating the coa Incident layer
  private _coaStrategyFeaturesSubject: BehaviorSubject<Array<StrategyFeatures>> = new BehaviorSubject([]);
  coaStrategyFeatures$: Observable<Array<StrategyFeatures>> = this._coaStrategyFeaturesSubject.asObservable();

  constructor(private httpSvc: HttpClient, private environment: ConfigService) { }


  getStrategicActionForWfdssCaseId(
    caseId: WfdssCase["wfdssCaseId"]
  ) {
    return this.httpSvc.get<IstrategicAction>(
      `${this.baseUrl}/cases/${caseId}/strategicAction`,
      {
        headers: Utilities.appendHTTPHeaderForInterceptor([
          EInterceptorOptionsHTTPHeaders.SuppressErrorInterceptor,
        ]),
      }
    );
  }

  getStrategicActionItemsForWfdssCase(
    caseId: WfdssCase["wfdssCaseId"]
  ): Observable<IstrategicActionItem[]> {
    return this.httpSvc
      .get<any>(
        `${this.baseUrl}/cases/${caseId}/strategicActionItems`
      )
      .pipe(
        map((response) => {
          return response.content as IstrategicActionItem[];
        })
      );
  }

  /**
   * @description: Creates or updates the strategic action for the corresponding wfdss case
   */
  putStrategicActionForWfdssCaseId(
    caseId: WfdssCase["wfdssCaseId"],
    strategicAction: IstrategicAction
  ) {
    const dataToSave = strategicAction;

    return this.httpSvc.put<IstrategicAction>(
      `${this.baseUrl}/cases/${caseId}/strategicAction`,
      dataToSave
    );
  }

  /* processSaveObject(strategicAction) {
     delete strategicAssessment.assessmentItemPriorities;
     return strategicAssessment;
   }*/

  createNewStrategicActionItem(
    caseId: WfdssCase["wfdssCaseId"],
    strategicActionItem: IstrategicActionItem
  ) {
    return this.httpSvc.put<IstrategicActionItem>(
      `${this.baseUrl}/cases/${caseId}/newStrategicActionItem`,
      strategicActionItem
    );
  }


  putStrategicActionItem(
    caseId: WfdssCase["wfdssCaseId"],
    strategicActionItemId: IstrategicActionItem["strategicCourseOfActionItemId"],
    actionItemData: IstrategicActionItem
  ) {
    return this.httpSvc.put<IstrategicActionItem>(
      `${this.baseUrl}/cases/${caseId}/strategicActionItem/${strategicActionItemId}`,
      actionItemData,
      {
        params: {
          timestampOfLastUpdate: 0,
          isForceOverwriteRequested: false,
        },
      }
    );
  }

  putStrategicActionItemPriorities(caseId: WfdssCase["wfdssCaseId"],
    strategicActionId: IstrategicActionItem["strategicCourseOfActionId"],
    actionItemPrioritiesData: IstrategicActionItem[]) {
    return this.httpSvc.put<IstrategicActionItem[]>(
      `${this.baseUrl}/cases/${caseId}/strategicAction/${strategicActionId}/updateStrategicActionItemPriorities`,
      actionItemPrioritiesData
    );
  }

  deleteStrategicActionItem(caseId: WfdssCase["wfdssCaseId"], saItemToDelete: IstrategicActionItem) {
    return this.httpSvc.delete(`${this.baseUrl}/cases/${caseId}/strategicActionItem/${saItemToDelete.strategicCourseOfActionItemId}`)
  }

  getReportedStrategyForWfdssCase(
    caseId: WfdssCase["wfdssCaseId"]
  ): Observable<IReportedStrategy> {
    return this.httpSvc
      .get<any>(
        `${this.baseUrl}/cases/${caseId}/reportedStrategy`,
        {
          headers: Utilities.appendHTTPHeaderForInterceptor([
            EInterceptorOptionsHTTPHeaders.SuppressErrorInterceptor,
          ]),
        }
      );
  }

  putReportedStrategy(
    caseId: WfdssCase["wfdssCaseId"],
    reportedStrategyData: IReportedStrategy
  ) {
    return this.httpSvc.put<IReportedStrategy>(
      `${this.baseUrl}/cases/${caseId}/reportedStrategy`,
      reportedStrategyData,
      {
        params: {
          timestampOfLastUpdate: 0,
          isForceOverwriteRequested: false,
        },
      }
    );
  }
 
  /**
   * Updates the coaStrategyFeatures Behavior Subject
   * @param features an array of StrategyFeatures
   */
  updateCOAStrategyFeatures(features: Array<StrategyFeatures>){
    this._coaStrategyFeaturesSubject.next(features);
  }
}
